import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, CalendarDays } from "lucide-react";
import { api } from "@/lib/api";
import { CATEGORIES, CATEGORY_KEYS, STATUS } from "@/lib/activity";
import { Header } from "@/components/landing/Header";
import { ContactSection } from "@/components/landing/ContactSection";
import { ActivityCard } from "@/components/activity/ActivityCard";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function KegiatanPublik() {
  const [profile, setProfile] = useState(null);
  const [items, setItems] = useState(null);
  const [category, setCategory] = useState("all");
  const [status, setStatus] = useState("all");
  const [range, setRange] = useState("upcoming");

  useEffect(() => {
    api.get("/profile").then((r) => setProfile(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setItems(null);
    const p = new URLSearchParams();
    if (category !== "all") p.set("category", category);
    if (status !== "all") p.set("status", status);
    if (range !== "all") p.set("upcoming", range === "upcoming" ? "true" : "false");
    api.get(`/activities?${p}`).then((r) => setItems(r.data)).catch(() => setItems([]));
  }, [category, status, range]);

  return (
    <div className="min-h-screen bg-background" data-testid="activities-page">
      <Header profile={profile} />
      <section className="emerald-bg pattern-overlay text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
          <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-200 hover:text-white" data-testid="activities-back-home"><ArrowLeft size={16} /> Kembali ke beranda</Link>
          <p className="mt-6 text-xs font-semibold uppercase tracking-[0.25em] text-[#80b996]">Agenda Masjid</p>
          <h1 className="mt-2 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">Kegiatan Masjid Al-Iman</h1>
          <p className="mt-3 text-emerald-100/85 max-w-2xl">Kajian rutin, shalat Jumat & Ied, qurban, Ramadhan, zakat fitrah, PHBI, hingga kegiatan sosial. Klik kartu untuk melihat detail, petugas, dan membagikannya.</p>
        </div>
      </section>
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="flex flex-wrap items-center gap-3" data-testid="activities-filters">
          <div className="inline-flex rounded-full border border-emerald-900/15 bg-white p-1">
            {[["upcoming", "Mendatang"], ["past", "Lampau"], ["all", "Semua"]].map(([k, l]) => (
              <button key={k} onClick={() => setRange(k)} className={`rounded-full px-4 py-1.5 text-sm font-medium ${range === k ? "emerald-bg text-white" : "text-slate-600 hover:text-emerald-900"}`} data-testid={`activities-range-${k}`}>{l}</button>
            ))}
          </div>
          <Select value={category} onValueChange={setCategory}>
            <SelectTrigger className="w-60 rounded-full bg-white" data-testid="activities-category-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Semua Kategori</SelectItem>
              {CATEGORY_KEYS.map((k) => <SelectItem key={k} value={k} data-testid={`activities-category-option-${k}`}>{CATEGORIES[k].label}</SelectItem>)}
            </SelectContent>
          </Select>
          <Select value={status} onValueChange={setStatus}>
            <SelectTrigger className="w-48 rounded-full bg-white" data-testid="activities-status-filter"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="all">Semua Status</SelectItem>
              {Object.entries(STATUS).map(([k, v]) => <SelectItem key={k} value={k}>{v.label}</SelectItem>)}
            </SelectContent>
          </Select>
          <span className="text-sm text-slate-500 ml-auto" data-testid="activities-count">{items ? `${items.length} kegiatan` : "Memuat..."}</span>
        </div>
        <div className="mt-8 grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items?.map((a) => <ActivityCard key={a.id} a={a} />)}
          {items?.length === 0 && (
            <div className="col-span-full rounded-3xl border border-dashed border-emerald-900/20 p-12 text-center text-slate-500" data-testid="activities-page-empty">
              <CalendarDays className="mx-auto mb-3 text-emerald-700" /> Tidak ada kegiatan pada filter ini.
            </div>
          )}
        </div>
      </main>
      <ContactSection profile={profile} />
    </div>
  );
}
